//import { ChartConfiguration } from "chart.js";

import {
  Chart,
  registerables
} from "chart.js";
import ChartDataLabels, {
  Context
} from 'chartjs-plugin-datalabels';

//import 'chart.js-plugin-labels-dv';

declare global {
  interface Window {
    __PtJsHelper: PtJsHelper;
  }
}

//export class PolarAreaConfig {
//  Options = new PolarAreaOptions
//}

// class BrowserWindowInfo {
//   public width: number;
//   public height: number;
//   public devicePixelRatio: number;
// }
export class PtJsHelper {
  private ChartsArray: Chart[] = [];
  // private static getDevicePixelRatio(): number {
  //   let mediaQuery;
  //   let is_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  //   if (window.devicePixelRatio !== undefined && !is_firefox) {
  //     return window.devicePixelRatio;
  //   } else if (window.matchMedia) {
  //     mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5),\
  //         (min--moz-device-pixel-ratio: 1.5),\
  //         (-o-min-device-pixel-ratio: 3/2),\
  //         (min-resolution: 1.5dppx)";
  //     if (window.matchMedia(mediaQuery).matches) {
  //       return 1.5;
  //     }
  //     mediaQuery = "(-webkit-min-device-pixel-ratio: 2),\
  //         (min--moz-device-pixel-ratio: 2),\
  //         (-o-min-device-pixel-ratio: 2/1),\
  //         (min-resolution: 2dppx)";
  //     if (window.matchMedia(mediaQuery).matches) {
  //       return 2;
  //     }
  //     mediaQuery = "(-webkit-min-device-pixel-ratio: 0.75),\
  //         (min--moz-device-pixel-ratio: 0.75),\
  //         (-o-min-device-pixel-ratio: 3/4),\
  //         (min-resolution: 0.75dppx)";
  //     if (window.matchMedia(mediaQuery).matches) {
  //       return 0.7;
  //     }
  //   } else {
  //     return 1;
  //   }
  // }

  // private getBrowserWindowInfo(): BrowserWindowInfo {
  //   const windowWidth: number = window.innerWidth
  //     || document.documentElement.clientWidth
  //     || document.body.clientWidth;
  //   const windowHeight: number = window.innerHeight
  //     || document.documentElement.clientHeight
  //     || document.body.clientHeight;
  //   const browserWindowInfo = new BrowserWindowInfo();
  //   browserWindowInfo.width = windowWidth;
  //   browserWindowInfo.height = windowHeight;
  //   browserWindowInfo.devicePixelRatio = PtJsHelper.getDevicePixelRatio();
  //   return browserWindowInfo;
  // }

  public async getOptionsAsync(
    url: string
  ): Promise<any> {
    return new Promise(async function (resolve, reject) {
      try {
        const options: any = {
          plugins: {
            tooltips: {
              callbacks: {
                label: function (tooltipItem: any, data: any) {
                  var label = data.datasets[tooltipItem.datasetIndex].label || '';

                  if (label) {
                    label += ': ';
                  }
                  label += Math.round(tooltipItem.yLabel * 100) / 100;
                  return label;
                }
              }
            }
          },
          responsive: false,
          scales: {
            r: {
              beginAtZero: true,
              max: 10,
              min: 0,
              ticks: {
                stepSize: 1,
                display: true,
                padding: 0
              }
            }
          }

        }
        return resolve(options);
      } catch (err) {
        return reject(new Error(err));
      } //catch
    }); //return new Promise
  }

  //public async update(chartNames: []){
  //  for (var id in Chart.instances) {
  //    console.log("Chartid: " + id);
  //    //Chart.instances[id].width = document.querySelector(".chart").offsetWidth;
  //    //Chart.instances[id].height = document.querySelector(".chart").offsetHeight;
  //    Chart.instances[id].update();
  //  }
  //}

  public async assignGrowthWheelCharts(dataSets: [], chartNames: [], colors: [], segmentTitles: []) {

    console.log("Entered assignGrowthWheelCharts()");

    Chart.register(...registerables);
    console.log("Registered registerables");
    Chart.register(ChartDataLabels);
    console.log("Registered ChartDataLabels");

    // const browserWindowInfo = this.getBrowserWindowInfo();

    const length = dataSets.length;

    for (let i = 0; i < length; i++) {
      console.log("Entered PtJsHelper.ts for loop: " + i);

      console.log(dataSets);
      console.log(chartNames);
      console.log(colors);
      console.log(segmentTitles);

      // let existingChartCanvas = document.getElementById(chartNames[i]) as HTMLCanvasElement;
      // console.log(existingChartCanvas);
      //
      // if (existingChartCanvas) {
      //   console.log("Existing chart canvas found");
      //  
      //   document.removeChild(existingChartCanvas);
      //   console.log("REMOVED Existing chart canvas");
      //  
      //   existingChartCanvas = null;
      // }

      const currentContext: any = <any>document.getElementById(chartNames[i]);

      const canvasParentDiv: any = <any>document.getElementById("canvasParentDiv");
      const outerDiv: any = <any>document.getElementById("outerDiv");
      console.log("outerDiv style.Width (before setting to browser width): " + outerDiv.style.width);
      console.log("outerDiv style.Height (before setting to browser height): " + outerDiv.style.height);

      // let adjustedWidth: number = ((browserWindowInfo.width) - 50);
      // let adjustedHeight: number = adjustedWidth;
      //
      // //set minimum height/width
      // if (adjustedHeight > this._maxWidth) {
      //   adjustedHeight = this._maxWidth;
      // }
      // if (adjustedWidth > this._maxWidth) {
      //   adjustedWidth = this._maxWidth;
      // }
      //
      // if (browserWindowInfo.width > browserWindowInfo.height) {
      //   currentContext.style.width = adjustedHeight;
      //   currentContext.style.maxWidth = currentContext.width;
      //
      //   canvasParentDiv.style.height = currentContext.width;
      //   canvasParentDiv.style.maxHeight = currentContext.width;
      //
      //   document.getElementById("outerDiv").style.width = adjustedHeight.toString() + "px";
      //   document.getElementById("outerDiv").style.maxWidth = adjustedHeight.toString() + "px";
      // } else {
      //   currentContext.style.width = adjustedWidth;
      //   currentContext.style.maxWidth = currentContext.width;
      //
      //   canvasParentDiv.style.height = currentContext.width;
      //   canvasParentDiv.style.maxHeight = currentContext.width;
      //
      //   document.getElementById("outerDiv").style.width = adjustedWidth.toString() + "px";
      //   document.getElementById("outerDiv").style.maxWidth = adjustedWidth.toString() + "px";
      // }
      // currentContext.width = currentContext.style.width;
      // currentContext.maxWidth = currentContext.style.width;
      //
      // canvasParentDiv.height = currentContext.style.width;
      // canvasParentDiv.maxHeight = currentContext.style.width;
      //
      // document.getElementById("outerDiv").style.height = document.getElementById("outerDiv").style.width;
      // document.getElementById("outerDiv").style.maxHeight = document.getElementById("outerDiv").style.width;
      //
      // const padding: any = adjustedHeight * 0.125;
      const padding: any = 70;

      console.log("Width: " + currentContext.width);
      console.log("Height: " + currentContext.height);
      console.log("Div Width: " + canvasParentDiv.width);
      console.log("Div Height: " + canvasParentDiv.height);
      console.log("Outer Div Width: " + outerDiv.width);
      console.log("Outer Div Height: " + outerDiv.height);
      console.log("Outer Div STYLE Width: " + outerDiv.style.width);
      console.log("Outer Div STYLE Height: " + outerDiv.style.height);

      console.log("Max Width: " + currentContext.maxWidth);
      console.log("Max Height: " + currentContext.maxHeight);
      console.log("Max Div Width: " + canvasParentDiv.maxWidth);
      console.log("Max Div Height: " + canvasParentDiv.maxHeight);
      console.log("Max Outer Div Width: " + outerDiv.maxWidth);
      console.log("Max Outer Div Height: " + outerDiv.maxHeight);

      let currentChart: Chart;

      if (i != (length - 1)) {
        currentChart = new Chart(
          currentContext, {
            type: 'polarArea',
            data: {
              labels: segmentTitles,
              datasets: [{
                label: 'Score',
                data: dataSets[i],
                backgroundColor: colors[i]
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: true,
              scales: {
                r: {
                  beginAtZero: true,
                  min: 0,
                  max: 10,
                  ticks: {
                    stepSize: 1,
                    display: true
                  }
                }//r
              },//scales
              plugins: {
                datalabels: {
                  display: false
                },
                legend: {
                  display: false
                },
                tooltip: {
                  enabled: false
                }
              },//plugins
              layout: {
                padding: {
                  top: padding,
                  bottom: padding,
                  left: padding,
                  right: padding
                }
                /*margin: 100*/
              }
            }//options
          } as any);//new chart
      } else {
        console.log("Entered else");
        i = length - 1;

        currentChart = new Chart(
          currentContext, {
            type: 'polarArea',
            data: {
              labels: segmentTitles,
              datasets: [{
                label: 'Score',
                data: dataSets[i],
                backgroundColor: colors[i],
                borderColor: 'rgba(0, 0, 0, 0.0)',
                hoverBorderColor: 'rgba(0, 0, 0, 0.0)',
                datalabels: {
                  labels: {
                    title: {
                      align: 'end',//
                      anchor: 'end',//
                      clip: false,//
                      clamp: false,
                      offset: 10,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      color: 'rgba(255, 255, 255, 1)'
                    },
                  }
                }
              }]
            },
            options: {
              responsive: true,
              maintainAspectRatio: true,
              scales: {
                r: {
                  beginAtZero: true,
                  min: 0,
                  max: 10,
                  ticks: {
                    stepSize: 1,
                    display: true
                  }
                }//r
              },//scales
              plugins: {
                datalabels: {
                  labels: {
                    title: {
                      formatter: function (value: any, ctx: Context) {//
                        const temp: any = ctx.chart.data.labels[ctx.dataIndex];
                        const tempArr = temp.split(":", 2);
                        return tempArr[0];
                      },
                      font: {
                        weight: 'bold',
                        size: 20
                      },
                      backgroundColor: 'rgba(255, 255, 255, 0.5)',
                      color: 'black'
                    }
                  }//
                },//datalabels
                legend: {
                  display: false
                },
                tooltip: {
                  enabled: false
                }
              },//plugins
              layout: {
                padding: {
                  top: padding,
                  bottom: padding,
                  left: padding,
                  right: padding
                }
                /*margin: 100*/
              },

            }//options
          } as any);//new chart
      }

      //currentChart.width = document.querySelector(".chart").offsetWidth;
      //currentChart.height = document.querySelector(".chart").offsetHeight;
      // currentChart.width = adjustedWidth;
      // currentChart.height = adjustedHeight;
      // currentChart.update();

      // const parentNode = currentChart.canvas.parentNode as any;

      // console.log("parentNode:");
      // console.log(parentNode);

      // parentNode.style.height = adjustedHeight;
      // console.log("set parentNode height to adjustedHeight");

      // parentNode.style.width = adjustedWidth;
      // console.log("set parentNode height to adjustedWidth");
      //

      // const adjustedWidth = currentChart.width;
      // const adjustedHeight = currentChart.height;
      // console.log("adjustedWidth: " + adjustedWidth);
      // console.log("adjustedHeight: " + adjustedHeight);
      //
      // currentChart.resize(adjustedWidth, adjustedHeight);
      // console.log("CALLED: currentChart.resize();");
      //
      // currentChart.update();
      // console.log("CALLED: currentChart.update();");

      var element = document.getElementById(chartNames[i]);
      console.log(element);
      element = document.getElementById("canvasParentDiv");
      console.log(element);
      element = document.getElementById("outerDiv");
      console.log(element);

      currentChart = currentChart;

      this.ChartsArray.push(currentChart);
    }//for

    console.log("After for loop");


    //code to have all datasets in one chart
    //var currentChart = new Chart(
    //  <any>document.getElementById("currentChart"), {
    //    type: 'polarArea',
    //    data: {
    //      labels: segmentTitles,
    //      datasets: [{
    //        label: 'Score',
    //        data: dataSets[i],
    //        backgroundColor: colors[i],
    //        datalabels: {
    //          labels: {
    //            title: {
    //              align: 'end',//
    //              anchor: 'end',//
    //              clip: false,//
    //              clamp: false,
    //              offset: -50
    //            },
    //          }
    //        }
    //      },
    //        {

    //        },
    //        {
    //          label: 'Score',
    //          data: dataSets[5],
    //          backgroundColor: colors[5],
    //          datalabels: {
    //            labels: {
    //              title: {
    //                align: 'end',//
    //                anchor: 'end',//
    //                clip: false,//
    //                clamp: false,
    //                offset: -50
    //              },
    //            }
    //          }
    //        },
    //      ]
    //    },
    //    options: {
    //      responsive: true,
    //      maintainAspectRatio: true,
    //      scales: {
    //        r: {
    //          beginAtZero: true,
    //          min: 0,
    //          max: 12,
    //          ticks: {
    //            stepSize: 1,
    //            display: true
    //          }
    //        }//r
    //      },//scales
    //      plugins: {
    //        datalabels: {
    //          labels: {
    //            title: {
    //              formatter: function (value: any, ctx: Context) {//
    //                var temp: any = ctx.chart.data.labels[ctx.dataIndex];
    //                var tempArr = temp.split("|", 2);
    //                return tempArr[0];//
    //              },
    //              font: {
    //                weight: 'bold',
    //                size: 20
    //              },
    //              backgroundColor: 'rgba(255, 255, 255, .5)',
    //              color: 'black'
    //            }
    //          }//
    //        },
    //        legend: {
    //          display: false
    //        },
    //        tooltip: {
    //          enabled: false
    //        }
    //      },//plugins
    //      layout: {
    //        padding: {
    //          top: 20,
    //          bottom: 20,
    //          left: 20,
    //          right: 20
    //        }
    //        /*margin: 100*/
    //      }
    //    }//options
    //  } as any);//new chart

    const outerDiv: any = <any>document.getElementById("outerDiv");
    console.log("outerDiv Width (after setting to browser width): " + outerDiv.width);
    console.log("outerDiv Height (after setting to browser height): " + outerDiv.height);
  }

  public async refreshCharts() {

    console.log("Entered refreshCharts()");

    this.ChartsArray.forEach(chart => {
      console.log("chart:");
      console.log(chart);

      const canvasParentDiv = chart.canvas.parentElement;
      console.log("canvasParentDiv:");
      console.log(canvasParentDiv);

      const outerDiv = canvasParentDiv.parentElement;
      console.log("outerDiv:");
      console.log(outerDiv);

      console.log("CALLING: chart.resize(outerDiv.offsetWidth, outerDiv.offsetHeight);");
      chart.resize(outerDiv.offsetWidth, outerDiv.offsetHeight);
    });
  }

  // public async assignQuickScanCharts(chartData: any[], chartLabels: []) {
  //   console.log("Entered assignQuickScanCharts()");
  //
  //   const chartColors = {
  //     three: '#58ffff',
  //     two: '#5cc4e0',
  //     one: '#6171b4',
  //     negOne: '#752b8e',
  //     negTwo: '#ac2585',
  //     negThree: '#ff3366'
  //   };
  //
  //   const chartNames = [
  //     'myPurposeChart',
  //     'myFocusChart',
  //     'mySkillsChart',
  //     'myRelationshipsChart',
  //     'myGrowthChart',
  //     'finalChartChart'
  //   ];
  //
  //   const chartTitles = [
  //     'MY PURPOSE',
  //     'MY FOCUS',
  //     'MY SKILLS',
  //     'MY RELATIONSHIPS',
  //     'MY GROWTH',
  //     'EXECUTION'
  //   ];
  //
  //
  //   Chart.register(...registerables);
  //   console.log("Registered registerables");
  //   Chart.register(ChartDataLabels);
  //   console.log("Registered ChartDataLabels");
  //
  //   const padding: any = 10;
  //
  //   for (var x = 0; x < chartNames.length; x++) {
  //     var currentChartColors: Array<string> = ['temp'];
  //     currentChartColors.pop();
  //     const currentContext: any = <any>document.getElementById(chartNames[x]);
  //
  //     for (var i = 0; i < chartData[x].length; i++) {
  //       console.log(currentChartColors);
  //       switch (chartData[x][i]) {
  //         case 3:
  //           currentChartColors.push(chartColors.three);
  //           break;
  //         case 2:
  //           currentChartColors.push(chartColors.two);
  //           break;
  //         case 1:
  //           currentChartColors.push(chartColors.one);
  //           break;
  //         case 0:
  //           currentChartColors.push(chartColors.one);
  //           break;
  //         case -1:
  //           currentChartColors.push(chartColors.negOne);
  //           break;
  //         case -2:
  //           currentChartColors.push(chartColors.negTwo);
  //           break;
  //         case -3:
  //           currentChartColors.push(chartColors.negThree);
  //           break;
  //         default:
  //           break;
  //       }
  //     }
  //
  //     let currentChart: Chart;
  //
  //     currentChart = new Chart(
  //       currentContext, {
  //         type: 'bar',
  //         data: {
  //           labels: chartLabels[x],
  //           datasets: [{
  //             data: chartData[x],
  //             backgroundColor: currentChartColors,
  //             datalabels: {
  //               display: false
  //             }
  //           }]
  //         },
  //         options: {
  //           responsive: true,
  //           maintainAspectRatio: true,
  //           plugins: {
  //             legend: {
  //               position: 'top',
  //               display: false
  //             },
  //             title: {
  //               display: true,
  //               text: chartTitles[x]
  //             }
  //           },
  //           scales: {
  //             y: {
  //               suggestedMax: 3,
  //               suggestedMin: -3,
  //               max: 3,
  //               min: -3
  //             }
  //           },//scales
  //           layout: {
  //             padding: {
  //               top: padding,
  //               bottom: padding,
  //               left: padding,
  //               right: padding
  //             }
  //             /*margin: 100*/
  //           }
  //         }
  //       }
  //     );
  //
  //     currentChart = currentChart;
  //    
  //     this.ChartsArray.push(currentChart);
  //   }
  // }

  // private readonly _maxWidth = 460;

  public async assignQuickScanRadarChart(chartData: any[], chartLabels: any[]) {
    console.log("Entered assignQuickScanRadarChart()");

    const Label_Font_Size: number = 10
    
    const M_Position: number = 9;
    const A_Position: number = 5;
    const P_Position: number = 1;
    const MAP_Font_Size: number = 20;
    
    Chart.register(...registerables);
    console.log("Registered registerables");
    Chart.register(ChartDataLabels);
    console.log("Before getelement");
    console.log("Registered ChartDataLabels and before getelement");
    
    const outerDiv: any = <any>document.getElementById("outerDiv");
    console.log(outerDiv)

    // console.log("outerDiv Width (before setting to browser width): " + outerDiv.width);
    console.log("outerDiv style.Width (before setting to browser width): " + outerDiv.style.width);
    // console.log("outerDiv Height (before setting to browser height): " + outerDiv.height);
    console.log("outerDiv style.Height (before setting to browser height): " + outerDiv.style.height);

    const mapLabelChartContext: any = <any>document.getElementById("mapLabelChart");
    console.log("After const mapLabelContext: any = <any>document.getElementById(\"mapLabelChart\");");
    console.log(mapLabelChartContext);

    const tempLabelArray: any = [];

    for (let i = 0; i < chartLabels.length; i++) {
      tempLabelArray.push(chartLabels[i]);
      tempLabelArray.push('');
    }

    console.log("tempLabelArray:");
    console.log({tempLabelArray});

    const padding: any = 0;
    //
    const quickScanRadarChartContext: any = <any>document.getElementById("quickScanRadarChart");
    console.log("After getelement");
    console.log(quickScanRadarChartContext);

    let numSectors = chartData.length;
    let sectorDegree = 360 / numSectors;

    //main chart for Quick Scan MAP
    let quickScanRadarChart: Chart = new Chart(
      quickScanRadarChartContext, {
        type: 'radar',
        data: {
          labels: chartLabels,
          datasets: [
            {
              data: chartData,
              backgroundColor: 'rgb(255, 51, 102)',
              borderColor: 'rgb(198, 197, 193)',
              borderDash: [15, 5],
              datalabels: {
                display: true,
                color: 'rgb(255, 255, 255)',
                labels: {
                  value: {
                    display: false,
                    formatter: function (value: any, ctx: any) {
                      console.log("in value formatter");
                      console.log("value:", value);

                      const formatted = ctx.dataset.data[ctx.dataIndex];
                      console.log("formatted:", formatted);

                      return formatted;
                    },
                    backgroundColor: 'rgba(255, 255, 255, 0.5)'
                  },
                  index: {
                    display: false
                  }
                }
              },
              pointRadius: 15,
              pointBackgroundColor: 'rgb(0,0,0)',
              pointHoverRadius: 15
            },
            {
              data: [-20, -20, -20, -20, -20, -20, -20, -20, -20, -20, -20, -20],
              backgroundColor: 'rgb(246, 154, 150)',
              borderColor: 'rgb(0, 0, 0)',
              borderWidth: 1,
              datalabels: {
                display: false,
                color: 'rgb(255, 255, 255)'
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0,0,0)',
              pointHitRadius: 0,
              tension: 0.3
            },
            {
              data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
              backgroundColor: 'rgb(244, 192, 188)',
              borderColor: 'rgb(0, 0, 0)',
              borderWidth: 1,
              datalabels: {
                display: false,
                color: 'rgb(255, 255, 255)'
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0,0,0)',
              pointHitRadius: 0,
              tension: 0.3
            },
            {
              data: [40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40, 40],
              backgroundColor: 'rgb(255, 255, 255, 1)',
              borderColor: 'rgb(0, 0, 0)',
              //borderDash: [10, 8],
              borderWidth: 1,
              datalabels: {
                display: false,
                color: 'rgb(255, 255, 255)'
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0, 0, 0)',
              pointHitRadius: 0,
              tension: 0.3
            },
            {
              data: [60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60, 60],
              backgroundColor: 'rgb(241, 240, 235, 1)',
              borderColor: 'rgb(0, 0, 0)',
              //borderDash: [10, 8],
              borderWidth: 1,
              borderDash: [5, 5],
              datalabels: {
                display: false,
                color: 'rgb(255, 255, 255)'
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0, 0, 0)',
              pointHitRadius: 0,
              tension: 0.3
            },
            {
              data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
              backgroundColor: 'rgb(221, 219, 204, 1)',
              borderColor: 'rgb(0, 0, 0)',
              datalabels: {
                display: false,
                color: 'rgb(255, 255, 255)',
                labels: {
                  index: {
                    align: function (context: any) {
                      return (sectorDegree * context.dataIndex) - sectorDegree;
                    },
                    anchor: "center",
                    offset: 0,//80
                    font: {
                      size: 20
                    }
                  }
                }
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0,0,0)',
              pointHitRadius: 0,
              tension: 0.3
            },
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              position: 'top',
              display: false
            },
            title: {
              display: false,
              text: 'temp'
            },
            datalabels: {
              labels: {
                index: {
                  formatter: function (value: any, ctx: Context) {
                    switch (ctx.dataIndex) {
                      case P_Position:
                        return 'P';
                      case A_Position:
                        return 'A';
                      case M_Position:
                        return 'M';
                      default:
                        return '';
                    }
                  },
                  font: {
                    weight: 'bold',
                    size: MAP_Font_Size
                  },
                  backgroundColor: 'transparent',
                  color: 'transparent'
                },
                tooltip: {
                  display: false
                }
              }
            }
          },
          scales: {
            r: {
              ticks: {
                z: 1,
                maxTicksLimit: 5
              },
              pointLabels: {
                font: {
                  weight: 'bold',
                  size: Label_Font_Size
                },
                color: 'white',
                backdropColor: function (value: any) {
                  console.log("in backdropColor");
                  console.log("value:", value);

                  const isLabelEmpty = value.label === '';
                  console.log("isLabelEmpty:", isLabelEmpty);

                  if (isLabelEmpty) {
                    return 'transparent'
                  } else {
                    return 'rgba(0, 0, 0, 0.5)';
                  }
                }
              },
              grid: {
                color: 'black',
                circular: true
              },
              angleLines: {
                color: 'black'
              },
              suggestedMin: -100,
              suggestedMax: 100
            },
          },//scales
          layout: {
            padding: {
              top: padding,
              bottom: padding,
              left: padding,
              right: padding
            }
          }
        }
      }
    );
    quickScanRadarChart = quickScanRadarChart;

    this.ChartsArray.push(quickScanRadarChart);

    const axisChartContext: any = <any>document.getElementById("axisChart");
    console.log("After const axisChartContext: any = <any>document.getElementById(\"axisChart\");");
    console.log(axisChartContext);

    //this chart is just overlayed over the previous one for axis purposes
    let axisChart: Chart = new Chart(
      axisChartContext, {
        type: 'radar',
        data: {
          labels: tempLabelArray,
          datasets: [
            {
              data: [-100, 100, -100, 100, -100, 100, -100, -100, -100, 100, -100, 100, -100, 100, -100, -100, -100, 100, -100, 100, -100, 100, -100],
              backgroundColor: 'rgb(221, 219, 205, 0)',
              borderColor: 'rgb(255, 255, 255, 1)',
              borderWidth: 2,
              borderDash: [5, 10],
              datalabels: {
                display: false
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0,0,0)',
              pointHitRadius: 0,
            },
            {
              data: [-100, -100, -100, -100, -100, -100, -100, 100, -100, -100, -100, -100, -100, -100, -100, 100, -100, -100, -100, -100, -100, -100, -100, 100],
              backgroundColor: 'rgb(221, 219, 205, 0)',
              borderColor: 'rgb(0, 0, 0, 1)',
              borderWidth: 2,
              datalabels: {
                display: false
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0,0,0)',
              pointHitRadius: 0,
            },
            {
              data: [100, 100, 100, 100, 100, 100, 100, 100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, 100, 100],
              backgroundColor: 'rgb(95, 178, 170, 0.3)',
              borderColor: 'rgb(0, 0, 0, 0)',
              borderWidth: 1,
              datalabels: {
                display: false
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0,0,0,0)',
              pointHitRadius: 0,
            },
            {
              data: [-100, -100, -100, -100, -100, -100, -100, 100, 100, 100, 100, 100, 100, 100, 100, 100, -100, -100, -100, -100, -100, -100, -100, -100],
              backgroundColor: 'rgb(213, 208, 184, 0.3)',
              borderColor: 'rgb(0, 0, 0, 0)',
              borderWidth: 1,
              datalabels: {
                display: false
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0,0,0,0)',
              pointHitRadius: 0,
            },
            {
              data: [-100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, -100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
              backgroundColor: 'rgb(195, 182, 138, 0.3)',
              borderColor: 'rgb(0, 0, 0, 0)',
              borderWidth: 1,
              datalabels: {
                display: false
              },
              pointRadius: 0,
              pointBackgroundColor: 'rgb(0,0,0,0)',
              pointHitRadius: 0,
            },
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              position: 'top',
              display: false
            },//legend
            title: {
              display: false,
              text: 'temp'
            },
            datalabels: {
              labels: {
                index: {
                  formatter: function (value: any, ctx: Context) {
                    switch (ctx.dataIndex) {
                      case P_Position:
                        return 'P';
                      case A_Position:
                        return 'A';
                      case M_Position:
                        return 'M';
                      default:
                        return '';
                    }
                  },
                  font: {
                    weight: 'bold',
                    size: MAP_Font_Size
                  },
                  backgroundColor: 'transparent',
                  color: 'transparent'
                },
                tooltip: {
                  display: false
                }
              }
            }
          },//plugins
          scales: {
            r: {
              min: -100,
              max: 100,
              ticks: {
                z: 1,
                maxTicksLimit: 5
              },
              pointLabels: {
                font: {
                  weight: 'bold',
                  size: Label_Font_Size
                },
                color: 'white',
                backdropColor: function (value: any) {
                  console.log("in backdropColor");
                  console.log("value:", value);

                  const isLabelEmpty = value.label === '';
                  console.log("isLabelEmpty:", isLabelEmpty);

                  if (isLabelEmpty) {
                    return 'transparent'
                  } else {
                    return 'rgba(0, 0, 0, 0.5)';
                  }
                }
              },
              grid: {
                color: 'rgba(255, 255, 255, 0)',
                circular: true
              },
              angleLines: {
                color: 'rgba(255, 255, 255, 0)'
              },

            },
          },//scales
          layout: {
            padding: {
              top: padding,
              bottom: padding,
              left: padding,
              right: padding
            }
            /*margin: 100*/
          }//layout
        }
      }
    );
    axisChart = axisChart;

    this.ChartsArray.push(axisChart);

    //this chart just displays the M an A and P labels in there correct positions
    let mapLabelChart: Chart = new Chart(
      mapLabelChartContext, {
        type: 'radar',
        data: {
          labels: chartLabels,
          datasets: [
            {
              data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              borderDash: [15, 5],
              datalabels: {
                display: true,
                color: 'transparent'
              },
              pointRadius: 15,
              pointBackgroundColor: 'transparent',
              pointHoverRadius: 15
            },
            {
              data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              borderWidth: 0,
              datalabels: {
                display: true,
                color: 'transparent'
              },
              pointRadius: 0,
              pointBackgroundColor: 'transparent',
              pointHitRadius: 0,
              tension: 0.3
            },
            {
              data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              borderWidth: 0,
              datalabels: {
                display: true,
                color: 'transparent'
              },
              pointRadius: 0,
              pointBackgroundColor: 'transparent',
              pointHitRadius: 0,
              tension: 0.3
            },
            {
              data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              //borderDash: [10, 8],
              borderWidth: 0,
              datalabels: {
                display: true,
                color: 'transparent'
              },
              pointRadius: 0,
              pointBackgroundColor: 'transparent',
              pointHitRadius: 0,
              tension: 0.3
            },
            {
              data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              //borderDash: [10, 8],
              borderWidth: 0,
              borderDash: [5, 5],
              datalabels: {
                display: true,
                color: 'transparent'
              },
              pointRadius: 0,
              pointBackgroundColor: 'transparent',
              pointHitRadius: 0,
              tension: 0.3
            },
            {
              data: [100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100, 100],
              backgroundColor: 'transparent',
              borderColor: 'transparent',
              borderWidth: 0,
              datalabels: {
                display: true,
                color: 'transparent'
              },
              pointRadius: 0,
              pointBackgroundColor: 'transparent',
              pointHitRadius: 0,
              tension: 0.3
            },
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              position: 'top',
              display: false
            },
            title: {
              display: false,
              text: 'temp'
            },
            datalabels: {
              labels: {
                index: {
                  formatter: function (value: any, ctx: Context) {
                    switch (ctx.dataIndex) {
                      case P_Position:
                        return 'P';
                      case A_Position:
                        return 'A';
                      case M_Position:
                        return 'M';
                      default:
                        return '';
                    }
                  },
                  font: {
                    weight: 'bold',
                    size: MAP_Font_Size
                  },
                  backgroundColor: function (value: any) {
                    console.log("in backgroundColor");
                    console.log("value:", value);

                    switch (value.dataIndex) {
                      case P_Position:
                      case A_Position:
                      case M_Position:
                        return 'rgba(255, 255, 255, 0.5)';
                      default:
                        return 'transparent';
                    }
                  },
                  color: 'black'
                },
                tooltip: {
                  display: false
                }
              }
            }
          },
          scales: {
            r: {
              ticks: {
                z: 1,
                maxTicksLimit: 5,
                color: 'transparent',
                backdropColor: 'transparent',
              },
              pointLabels: {
                font: {
                  weight: 'bold',
                  size: Label_Font_Size
                },
                color: 'transparent',
                backdropColor: 'transparent'
              },
              grid: {
                color: 'transparent',
                circular: true
              },
              angleLines: {
                color: 'transparent'
              },
              suggestedMin: -100,
              suggestedMax: 100
            },
          },//scales
          layout: {
            padding: {
              top: 30,
              bottom: 30,
              left: 30,
              right: 30
            }
            /*margin: 100*/
          }//layout
        }
      }
    );
    mapLabelChart = mapLabelChart;

    this.ChartsArray.push(mapLabelChart);
  }
}

declare namespace globalThis {
  let __PtJsHelper: PtJsHelper;
}

// TODO: is this needed with the below listener event???
globalThis.__PtJsHelper = new PtJsHelper();
window.__PtJsHelper = globalThis.__PtJsHelper;
